import React from 'react'

export default function Header({ title }) {
	return (
		<div className='header-Container'>
			<div className='img-Container'>
				<a href='https://leasequery.com/'>
					<img
						src='https://leasequery.com/wp-content/uploads/2021/06/leasequery-logo.png'
						alt='LeaseQuery'
						id='logo'
						className='header-Logo'
					/>
				</a>
			</div>
			<div className='text-Header'>
				<span>{title}</span>
			</div>
			<div className='div-Right'>
				<div className='header-Right'></div>
			</div>
		</div>
	)
}
